import React from "react";
import PropTypes from "prop-types";
import NewsItem from "./components/NewsItem";
import { connect } from "react-redux";
import { Translate } from "react-redux-i18n";
import MiniLoader from "components/MiniLoader";

const News = (props) => {
    return (
        <section className="stock-news-section">
            <h2 className="stock-section-title">
                <Translate value="stock_news" />
            </h2>
            {props.loading && !props.list.length ? (
                <div className="stock-loading">
                    <MiniLoader />
                </div>
            ) : props.list.length === 0 ? (
                <p className="stock-empty"><Translate value="stock_no_news" /></p>
            ) : (
                props.list.map((item) => (
                    <NewsItem key={item.id} item={item} />
                ))
            )}
        </section>
    );
};

News.propTypes = {
    className: PropTypes.string,
};

function mapStateToProps(reducer) {
    return {
        list: reducer.stockNews.list,
        loading: reducer.stockNews.loading,
    };
}

export default connect(mapStateToProps)(News);
